"use strict";
/**
 * @license
 * Copyright 2018 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
Object.defineProperty(exports, "__esModule", { value: true });
var engine_1 = require("../engine");
var tensor_util_env_1 = require("../tensor_util_env");
var operation_1 = require("./operation");
var scatter_nd_util = require("./scatter_nd_util");
/**
 * Creates a new tensor by applying sparse updates to individual
 * values or slices within a zero tensor of the given shape tensor according to
 * indices. This operator is the inverse of the `tf.gatherND` operator which
 * extracts values or slices from a given tensor.
 *
 * ```js
 * const indices = tf.tensor2d([4, 3, 1, 7], [4, 1], 'int32');
 * const updates = tf.tensor1d([9, 10, 11, 12]);
 * const shape = [8];
 * tf.scatterND(indices, updates, shape).print() //[0, 11, 0, 10, 9, 0, 0, 12]
 * ```
 *
 * @param indices The tensor contains the indices into the output tensor.
 * @param updates The tensor contains the value for the indices.
 * @param shape: The shape of the output tensor.
 */
/** @doc {heading: 'Operations', subheading: 'Slicing and Joining'} */
function scatterND_(indices, updates, shape) {
    var $indices = tensor_util_env_1.convertToTensor(indices, 'indices', 'scatterND', 'int32');
    var $updates = tensor_util_env_1.convertToTensor(updates, 'updates', 'scatterND');
    scatter_nd_util.validateInput($updates, $indices, shape);
    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.scatterND($indices, $updates, shape); }, { indices: $indices, updates: $updates }, null /* backward */, 'ScatterNd', { shape: shape });
}
exports.scatterND = operation_1.op({ scatterND_: scatterND_ });
//# sourceMappingURL=scatter_nd.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@tensorflow/tfjs-core/dist/ops/scatter_nd.js
 ** module id = 1066
 ** module chunks = 0
 **/